import React, { useMemo } from 'react';
import { calculateFinancials } from '../../services/financialCalculations';
import { formatCurrency, formatPercentage } from '../../utils/formatters';

const BessArbitrageSpreadSensitivityTable = ({ inputs }) => {
    const { sensitivityData, arbitrageSpreadRange, degradationRange } = useMemo(() => {
        const baseArbitrageSpread = inputs.bessArbitrageSpread;
        const baseDegradation = inputs.bessDegradationRate;

        const arbitrageSpreadRange = [-0.2, -0.1, 0, 0.1, 0.3].map(mod => baseArbitrageSpread * (1 + mod));
        const degradationRange = [-0.4, -0.2, 0, 0.2, 0.4].map(mod => baseDegradation * (1 + mod));

        const sensitivityData = degradationRange.map(degradation => {
            return arbitrageSpreadRange.map(spread => {
                const tempInputs = { ...inputs, bessArbitrageSpread: spread, bessDegradationRate: degradation };
                const results = calculateFinancials(tempInputs);
                return results.indicators.projectNPV;
            });
        });

        return { sensitivityData, arbitrageSpreadRange, degradationRange };
    }, [inputs]);

    if (!inputs.bessEnabled) return null;

    return (
        <div className="mt-6">
            <h4 className="text-md font-semibold text-purple-800 dark:text-purple-100 mb-2">🔋 BESS Arbitrage Spread vs Degradation Rate (Project NPV)</h4>
            <div className="overflow-x-auto">
                <table className="min-w-full text-sm text-center border-collapse border border-purple-300 dark:border-purple-600">
                    <thead className="bg-purple-100 dark:bg-purple-700">
                        <tr>
                            <th className="p-2 border border-purple-300 dark:border-purple-600">
                                <div className="flex flex-col items-center">
                                    <span className="font-bold">Degradation ↓</span>
                                    <span className="font-normal text-xs">Arbitrage Spread →</span>
                                </div>
                            </th>
                            {arbitrageSpreadRange.map((spread, index) => (
                                <th key={index} className="p-2 border border-purple-300 dark:border-purple-600 font-medium">{formatPercentage(spread)}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {sensitivityData.map((row, rowIndex) => (
                            <tr key={rowIndex}>
                                <td className="p-2 border border-purple-300 dark:border-purple-600 font-medium bg-purple-50 dark:bg-purple-700">
                                    {formatPercentage(degradationRange[rowIndex])}
                                </td>
                                {row.map((npv, colIndex) => (
                                    <td key={colIndex} className={`p-2 border border-purple-300 dark:border-purple-600 ${npv > 0 ? 'bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-200' : 'bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-200'}`}>
                                        {formatCurrency(npv, 0)}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default BessArbitrageSpreadSensitivityTable; 